import styled from "styled-components/macro";

import {useToast} from "@chakra-ui/react";
import {createRef} from "react";
import Header from "../../components/header";
import TopBar from "../../components/top_bar";
import SortBar from "../../components/sort_bar";
import CommunityHeader from "../../components/community_header";
import Container from "../../components/container";
import Main from '../../components/main';
import Sidebar from "../../components/sidebar";
import Footer from "../../components/footer";
import Wrapper from "../../components/wrapper";
import {useAllCommunities, useCommunities, useCommunityStyle, useCommunitySubscribe} from "../../api/communities";
import {useBaseCommunity} from "../../store/hooks";
import HeaderData from "../../components/header_data";
import {useFeedback} from "../../store/feedback";
import Button from "../../components/button";
import CommunityLogo from "../../components/community_logo";
import NavLink from "../../components/nav_link";
import Pagination from "../../components/pagination";
import {useQuery} from "../../utils/router";
import {useLoggedIn, useSettings} from "../../store";
import {isPseudoCommunity} from "../../store/communites";
import {themecolors} from "../../utils/themecolors";
import {ChevronLeft, ChevronRight, Star} from "lucide-react";

const Subscribe = styled(Button)``;
const Info = styled.div``;
const Title = styled.div``;
const Description = styled.div``;
const Logo = styled.div``;
const Text = styled.div``;
const ShowPolitics = styled.div``;

const TOPICS = ['Subscribed', 'Recommended', 'All', 'Discussion', 'Sports', 'Gaming', 'Culture', 'Guns', 'Hobbies', 'Memes', 'Cars',
'Videos', 'Stories', 'Technology', 'Streaming', 'Entertainment', 'Movies', 'TV', 'Humor',
'Lifestyle', 'News', 'Places', 'Finance', 'GIFs', 'Music', 'Politics'];

const FeedBarOuter = styled.div``;
const FeedBarInner = styled.div``;
const FeedDescription = styled.div``;
const FeedTitle = styled.div``;
const SaveFeed = styled.div``;
const EditFeed = styled.div``;
const FeedBarActive = styled.div``;
const FeedBarArrow = styled.div``;
const FeedBarSuggestions = styled.div``;
const FeedBarItems = styled.div``;
const FeedBarItem = styled.div``;

const TopicBar = styled(({className, activeTopic}) => {

    const loggedIn = useLoggedIn();

    const navRef = createRef();
    const handleNav = (direction) => {
        if (direction === 'left') {
            navRef ? (navRef.current.scrollLeft -= 300) : null;
        } else {
            navRef ? (navRef.current.scrollLeft += 300) : null;
        }
    }

    return (
        <FeedBarOuter className={className}>
            <FeedBarInner>
                <FeedBarArrow onClick={() => handleNav('left')}>
                    <ChevronLeft size={22} />
                </FeedBarArrow>
                <FeedBarSuggestions ref={navRef}>
                    <FeedBarItems>
                        {TOPICS?.map((topic) => (loggedIn || topic !== 'Subscribed') && (
                            <NavLink href={`/communities?sort=topics&topic=${topic}`} react_route key={topic}>
                                <FeedBarItem className={topic.toLowerCase() === activeTopic.toLowerCase() ? 'active-feed' : ''}>{topic}</FeedBarItem>
                            </NavLink>
                        ))}
                    </FeedBarItems>
                </FeedBarSuggestions>
                <FeedBarArrow onClick={() => handleNav('right')}>
                    <ChevronRight size={22} />
                </FeedBarArrow>
            </FeedBarInner>
        </FeedBarOuter>
    );
})`
  margin-bottom: 12px;
  
  ${FeedBarInner} {
    max-width: ${({theme}) => theme.fullWidth ? '100%' : '1360px'};
    margin: 0 auto;
    font-size: 18px;
    font-weight: 500;
    display: flex;
    align-items: center;
  }
  ${FeedBarActive} {
    margin-right: 24px;
    max-width: 332px;
    white-space: nowrap;
  }
  ${FeedTitle} {
    display: flex;
    align-items: center;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  ${SaveFeed}, ${EditFeed} {
    margin-left: 8px;
    cursor: pointer;
    font-size: 13px;
  }
  ${FeedDescription} {
    font-weight: 400;
    font-size: 13px;
    color: #a89e9e;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  ${FeedBarArrow} {
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  ${FeedBarArrow}:last-of-type {
    margin-left: auto;
  }
  
  ${FeedBarSuggestions} {
    display: flex;
    height: 36px;
    flex-grow: 1;
    overflow: scroll;
    -ms-overflow-style: none;  /* IE and Edge */
    scrollbar-width: none;  /* Firefox */
  }
  ${FeedBarSuggestions}::-webkit-scrollbar {
    display: none;
  }
  
  ${FeedBarItem} {
    border-radius: 48px;
    padding: 0 20px;
    font-size: 15px;
    font-weight: 400;
    cursor: pointer;
    white-space: nowrap;
    height: 36px;
    margin: 0 4px;
    background-color: ${({theme}) => theme.color.name === 'dark' ? '#1a1a1c' : 'transparent'};
    display: flex;
    align-items: center;
    color: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_medium_impact_text : themecolors.light_medium_impact_text};
  }
  
  ${FeedBarItem} img {
    width: 20px;
    margin-right: 6px;
    border-radius: 50%;
  }

  ${FeedBarItems} {
    flex-grow: 1;
    display: flex;
    overflow: hidden;
    flex-shrink: 0;
  }
  .active-feed {
    background-color: ${({theme}) => theme.color.name === 'dark' ? '#343636' : '#fff'};
  }

  @media only screen and (max-width: 780px) {
    & {
      margin-bottom: 0;
    }
    ${FeedBarInner} {
      height: auto;
      padding: 6px;
    }
    ${FeedBarActive} {
      margin-bottom: 12px;
    }
  }
  
`;

const Community = styled(({className, community, onSubscribe}) => {
    const {name, description} = community;
    const toast = useToast();
    const handleSubscribe = async () => {
            try {
                await onSubscribe([community.name]);
            } catch {
                toast({
                    title: 'Something went wrong.',
                    status: 'error',
                    isClosable: true,
                })
            }
    }
    return (
        <div className={className}>
            <Info>
                <Logo>
                    <CommunityLogo name={name} />
                </Logo>
                <Text>
                    <Title>
                        <NavLink href={`/c/${name}/`} react_route>
                            {name}
                        </NavLink>
                        {<Subscribe onClick={handleSubscribe}>
                            {community.is_subscribed
                                ? <Star fill={"#ffbe00"} style={{color: '#ffbe00'}} size={16} />
                                : <Star style={{color: '#70767b'}} size={16} />}
                        </Subscribe>}
                    </Title>
                    <Description>
                        {description}
                    </Description>
                </Text>
            </Info>
        </div>
    );
})`
  font-size: 14px;
  padding-bottom: 32px;
  &:last-of-type {
    padding-bottom: 0;
  }

  img {
    min-width: 40px;
    max-width: 40px;
    height: 40px;
    border-radius: 50%;
  }

  ${Info} {
    display: flex;
    align-items: center;
  }

  ${Title} {
    font-weight: 600;
    font-size: 15px;
    display: flex;
    align-items: center;
  }
  
  ${Description} {
    font-size: 15px;
    color: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_medium_impact_text : themecolors.light_medium_impact_text};
  }
  ${Subscribe} {
    border-radius: 4px;
    background-color: inherit;
    padding: 6px 12px;
    font-size: 14px;
    font-weight: 700;
  }
  ${Text} {
    margin-left: 12px;
  }
`;

const Communities = styled(({className}) => {

    const loggedIn = useLoggedIn();
    const baseCommunity = useBaseCommunity();
    const style = useCommunityStyle(baseCommunity);

    const {error, feedbackCh} = useFeedback();
    const topic = useQuery().topic || (loggedIn ? 'subscribed' : 'recommended');
    const page = parseInt(useQuery().page || '1');
    const {subscribed} = useSettings();

    const communities = useAllCommunities(feedbackCh, 'activity', topic, page, true);
    const subscribedCommunities = useCommunities(feedbackCh, subscribed);
    const sorted = subscribedCommunities.sort((a, b) => (a.name > b.name) ? 1 : -1)

    const communityList = topic.toLowerCase() === 'subscribed' ? sorted : communities;
    const subscribe = useCommunitySubscribe(feedbackCh);

    return (
        <div className={className}>
            <HeaderData title='Communities' community={baseCommunity} community_style={style}/>
            <Header>
                <TopBar page={'Communities'} />
                {!isPseudoCommunity(baseCommunity) &&
                    <>
                        <CommunityHeader community={baseCommunity}/>
                    </>
                }
            </Header>
            <SortBar community={baseCommunity} />
            <Container>
                <Wrapper>
                    <TopicBar activeTopic={topic} />
                    <Main>
                        {communityList?.map((community) => community && (
                            <Community
                                key={community.name}
                                community={community}
                                onSubscribe={subscribe}
                            />
                        ))}
                    </Main>
                    <Pagination path={`/communities?${topic ? `sort=topics&topic=${topic}&` : ''}page=`} has_more page={page} />
                </Wrapper>
                <Sidebar sidebar={style && style.sidebar} community={baseCommunity} />
            </Container>
            <Footer />
        </div>
    );
})`
${Main} {
  padding: 20px;
}
${ShowPolitics} {
  padding-bottom: 12px;
}
  ${Wrapper} {
  
  }
  @media only screen and (max-width: 780px) {
    ${ShowPolitics} {
      padding: 0 12px 12px 12px;
    }
  }
`;

export default Communities;
